import React from 'react';
import '../styles/success.css';
import leftImage from '../assets/landing1.jpg'; // Use your main left-side image
import successIcon from '../assets/success.jpg'; // Use a green check/tick png icon, add it to your assets

const Success = () => {
  return (
    <div className="success-page">
      {/* Left Image Section */}
      <div className="left-side">
        <img src={leftImage} alt="Lingayath Weds" className="left-image" />
      </div>

      {/* Right Success Section */}
      <div className="right-side">
        <div className="success-card">
          <h1 className="title">Welcome to Lingayath Weds</h1>
          <div className="success-content">
            <div className="icon-container">
              <img src={successIcon} alt="Success" className="success-icon" />
            </div>
            <p className="success-message">
              You've logged in successfully. You are being redirected to your home page.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Success;
